<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-03-15 10:41:10
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-03-20 09:32:28
 * @FilePath: \vue-hd-ota\src\views\smallProgram\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <!-- 查询 -->
        <div class="searchPanel">
            <SearchForm 
                :class="{queryForm_en:lang == 'en', queryForm_zh:lang == 'zh'}" 
                :form="queryForm"
                @handleInputChange="handleInputChange"
                @handleSelectChange="handleQuerySelectChange"
                @handlePressEnter="handleQueryPressEnter"
            ></SearchForm>
        </div>

        <Table
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <!-- 表头自定义按钮 -->
            <template v-slot:operateBtn>
                <a-button type="primary" size="small" class="operate_btn" @click="handle('add')">
                    <component :is="$antIcons['PlusOutlined']"></component>
                    {{$t('base.add')}}
                </a-button>
            </template>
            
            <!-- 表格列自定义列内容 -->
            <template v-slot:customCol="{props}">
                <template v-if="props.column.key === 'status'">
                    <div class="editable-cell"> 
                        <a-tag
                            :color="props.record.status_val === 0 ? 'green' : 'red'"
                        >{{ props.record.status }}</a-tag>
                    </div>
                </template>
            </template>

            <!-- 表格操作按钮 -->
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="link" size="small" :disabled="props.record.status_val == 1" style="margin-right:10px" @click="handle('stop',props.record)">
                        {{$t('smallProgram.stop')}}
                    </a-button>
                    <a-button type="link" size="small" :disabled="props.record.status_val == 0" style="margin-right:10px" @click="handle('enable',props.record)">
                        {{$t('smallProgram.enable')}}
                    </a-button> 
                    <a-button type="link" size="small" style="margin-right:10px" @click="handle('edit',props.record)">
                        {{$t('base.edit')}}
                    </a-button> 
                    <a-button type="link" size="small" :disabled="props.record.status_val == 0" style="margin-right:10px" @click="handle('delete',props.record)">
                        {{$t('smallProgram.delete')}}
                    </a-button> 
                </template>
            </template>
        </Table>

        <!-- 新增小程序 -->
        <a-modal 
            v-model:visible="visible" 
            :title="t('smallProgram.add_app')" 
            width="700px"
            @cancel="handleCancel"
            @ok="handleOk"
        >
            <a-form layout="vertical" :model="formState" v-bind="formItemLayout">
                <a-form-item :label="t('smallProgram.app_id')" v-bind="validateInfos.app_id">
                    <a-input v-model:value="formState.app_id" allowClear :maxlength="100" :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('smallProgram.app_name')" v-bind="validateInfos.app_name">
                    <a-input v-model:value="formState.app_name" allowClear :maxlength="100" :placeholder="t('base.enter')" />
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 编辑小程序 -->
        <a-modal 
            v-model:visible="editVisible" 
            title="编辑小程序" 
            width="700px"
            @cancel="handleCancel"
            @ok="editSmallProgram"
        >
            <a-form layout="vertical" :model="formState" v-bind="formItemLayout">
                <a-form-item :label="t('smallProgram.app_id')" v-bind="validateInfos.app_id">
                    <a-input v-model:value="formState.app_id" disabled allowClear :maxlength="100" :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('smallProgram.app_name')" v-bind="validateInfos.app_name">
                    <a-input v-model:value="formState.app_name" allowClear :maxlength="100" :placeholder="t('base.enter')" />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch } from "vue";
    import Table from "@/components/Table.vue";
    import SearchForm from "@/components/Form.vue";
    import { useRouter } from "vue-router";
    import { QueryForm } from './js/formConfig.js';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
    import { SmallProgramApi } from '@/api/SmallProgramApi.js';
    import { debounce } from 'lodash-es';
    import { timestampToDate } from '@/utils/global.js'
    import { Form } from 'ant-design-vue';

    const { t } = useI18n()

    const useForm = Form.useForm
    const queryForm = reactive(QueryForm)
    const visible = ref(false)
    const editVisible = ref(false)
    const rowData = ref(null)
    const table = ref({
        data: [],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('smallProgram.app_id'),
                dataIndex: 'app_id',
                key: 'app_id',
                width: 70,
                resizable: true,
            },
            {
                title: t('smallProgram.app_name'),
                dataIndex: 'app_name',
                key: 'app_name',
                width: 70,
                resizable: true,
            },
            {
                title: t('smallProgram.status'),
                dataIndex: 'status',
                key: 'status',
                width: 100,
                resizable: true,
            },
            {
                title: t('user.create_timestamp'),//'创建日期'
                dataIndex: 'create_time',
                key: 'create_time',
                width: 120,
                resizable: true,
            },
            {
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 130,
                resizable: true,
            },
        ],
        configs: {
            table: {
                pagination: {
                    total: 0,
                },
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: true,
            pagination: {
                hideOnSinglePage: false,
                position: ['bottomLeft'],
                responsive: true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50'],
                total: 0,
                showTotal: () => t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const formState = reactive({
        app_id:'',
        app_name:'',
    })
    const rulesRef = reactive({
        app_id: [
            {
                required: true,
                message: '小程序app_id不能为空！',
            },
        ],
        app_name: [
            {
                required: true,
                message: '小程序名称不能为空！',
            },
        ],
    });

    const handle = (type, row)=>{
        switch(type){
            case 'add':
                visible.value = true
                for(let key in formState){
                    formState[key] = ''
                }
                resetFields()
                break;
            case 'stop': // 禁用
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认禁用该小程序?',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        setAuth(1, row)
                    },
                });
                break;
            case 'enable': // 启用
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认启用该小程序?',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        setAuth(0, row)
                    },
                });
                break;
            case 'edit': // 编辑
                editVisible.value = true
                rowData.value = row
                formState.app_id = row.app_id
                formState.app_name = row.app_name
                break;
            case 'delete': // 删除
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认删除该小程序?',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        deleteSmallProgram(row)
                    },
                });
                break;
        }
    }

    const handleInputChange = debounce((val, key)=>{
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }, 1000)

    const handleQueryPressEnter = (val, key)=>{
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    const handleQuerySelectChange = (val, key)=>{
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    // 分页
    function handleChangePagination(config, data) {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    // 获取用户列表
    const getList = async ()=> {
        let param = {
            ...queryForm.formData,
            status: queryForm.formData.status == null? '' : queryForm.formData.status
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await SmallProgramApi.getInstance().getSmallProgramList(param, page_num, page_size)
        if (res.code == 0) {
            let data = res.data
            data.records.forEach((i, index) => {
                i.serial = index + 1
                i.status_val = i.status == undefined? '-' : i.status
                i.status = i.status == 0? t('smallProgram.enable') : t('smallProgram.stop')
                i.create_time = i.create_time == undefined? '-' : i.create_time
            })
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current
            table.value.data = data.records

            table.value.configs.loading = false
        } else {
            message.error(res.msg);
        }
    }

    // 新增用户
    const { resetFields, validate, validateInfos } = useForm(formState, rulesRef, {});
    const handleOk = ()=>{
        validate().then(async () => {
            let param = {
                app_id: formState.app_id,
                app_name:  formState.app_name,
            }
            let res = await SmallProgramApi.getInstance().addSmallProgram(param, formState.app_id)
            if (res.code == 0) {
                message.success('新增成功！');
                visible.value = false
                table.value.configs.pagination.current = 1
                getList()
            } else {
                message.error(res.msg);
            }
        }).catch(err => {
            console.log('error', err);
        })
    }
    const handleCancel = ()=>{
        resetFields()
    }

    // 禁用/启用小程序
    const setAuth = async (status,row)=>{
        let param = {
            app_id : row.app_id,
            status:status,
        }
        let res = await SmallProgramApi.getInstance().setAuth(param, row.app_id)
        if (res.code == 0) {
            status == 0? message.success('已启用') :  message.success('已禁用') 
            table.value.configs.pagination.current = 1
            getList()
        } else {
            message.error(res.msg);
        }
    } 

    // 删除小程序
    const deleteSmallProgram = async (row)=>{
        let res = await SmallProgramApi.getInstance().deleteSmallProgram(row.id)
        if (res.code == 0) {
            table.value.configs.pagination.current = 1
            getList()
        } else {
            message.error(res.msg);
        }
    }

    // 编辑小程序
    const editSmallProgram = ()=>{
        validate().then(async () => {
            let param = {
                app_id: formState.app_id,
                app_name: formState.app_name,
            }
            let res = await SmallProgramApi.getInstance().editSmallProgram(param, rowData.value.app_id)
            if (res.code == 0) {
                editVisible.value = false
                table.value.configs.pagination.current = 1
                getList()
            } else {
                message.error(res.msg);
            }
        }).catch(err => {
            console.log('error', err);
        })
    }

    onMounted(()=>{
        getList()
    })
</script>

<style lang="scss" scoped>
.searchPanel{
    margin-bottom: 5px;
    background: #fff;
    border-bottom: 1px dashed #ddd;

    ::v-deep .ant-form-item{
        margin-bottom: 4px;
    }
}

::v-deep .ant-table tfoot>tr>td, 
::v-deep .ant-table tfoot>tr>th, 
::v-deep .ant-table-tbody>tr>td, 
::v-deep .ant-table-thead>tr>th {
    overflow-wrap: break-word;
    padding: 14px;
    position: relative;
}
</style>